export interface BundleTextType {
    parentVariantId?: string;
    subs?: BundleItemType[];
    link_buy?: string;
    power?: string;
    desc?: string;
    quantity?: number;
    tip?: string;
    btn?: string;
}

export interface ProductAPIType {
    variantId: string;
    productId: string;
    sku: string;
    inventoryQuantity: number;
    inventoryPolicy: string;
    price: number;
    compareAtPrice: number;
    img: string;
    variantImg: string;
    productTitle: string;
    skuTitle: string;
    handle: string;
}

export interface BundleItemType extends ProductAPIType, BundleTextType {}

export interface BundleIdsType {
    [key: string]: BundleItemType[];
}

// 预热阶段bundleIds
export const bundleIdsTeaser: BundleIdsType = {
    us: [
        {
            ...({} as BundleItemType),
            productId: '15391292588105',
            variantId: '54720023330889',
            btn: 'Deposit Now',
            link_buy: 'https://us.ecoflow.com/products/delta-pro-ultra-x',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1758781342501/DPUX_2EB.png',
        },
        {
            ...({} as BundleItemType),
            productId: '15391292588105',
            variantId: '54720023330889',
            btn: 'Deposit Now',
            link_buy: 'https://us.ecoflow.com/products/delta-pro-ultra-x',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1758781342217/DPUX_2EB_SHP3.png',
        },
        {
            ...({} as BundleItemType),
            productId: '15391292588105',
            variantId: '54720023330889',
            btn: 'Deposit Now',
            link_buy: 'https://us.ecoflow.com/products/delta-pro-ultra-x',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1758781342063/DPUX_2EB_ATS.png',
        },
    ],
    ca: [
        {
            ...({} as BundleItemType),
            productId: '15178584981875',
            variantId: '62111365759347',
            btn: 'Deposit Now',
            link_buy: 'https://ca.ecoflow.com/products/delta-pro-ultra-x',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1758781342501/DPUX_2EB.png',
        },
    ],
};

// 正式阶段bundleId （super_earl、early、regular）
export const bundleIds: BundleIdsType = {
    us: [
        {
            ...({} as BundleItemType),
            productId: '15391292588105',
            variantId: '54714781171785',
            subs: [
                {
                    ...({} as BundleItemType),
                    productId: '15392480264265',
                    variantId: '54720265257033',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15392477970505',
                    variantId: '54720259293257',
                },
                {
                    ...({} as BundleItemType),
                    productId: '6970777174089',
                    variantId: '54572871614537',
                },
            ],
        },
        {
            ...({} as BundleItemType),
            productId: '15391292588105',
            variantId: '54714781204553',
            subs: [
                {
                    ...({} as BundleItemType),
                    productId: '15392480264265',
                    variantId: '54720265257033',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15392477970505',
                    variantId: '54720259293257',
                },
                {
                    ...({} as BundleItemType),
                    productId: '6970777174089',
                    variantId: '54572871614537',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15343862284361',
                    variantId: '54720237437001',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15343862284361',
                    variantId: '54732545228873',
                },
            ],
        },
        {
            ...({} as BundleItemType),
            productId: '15391292588105',
            variantId: '54714781237321',
            subs: [
                {
                    ...({} as BundleItemType),
                    productId: '15392480264265',
                    variantId: '54720265257033',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15392477970505',
                    variantId: '54720259293257',
                },
                {
                    ...({} as BundleItemType),
                    productId: '6970777174089',
                    variantId: '54572871614537',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15343862284361',
                    variantId: '54720237469769',
                },
                {
                    ...({} as BundleItemType),
                    productId: '15343862284361',
                    variantId: '54732545261641',
                },
            ],
        },
    ],
    ca: [
        {
            ...({} as BundleItemType),
            productId: '15178584981875',
            variantId: '62111365792115',
            subs: [
                {
                    ...({} as BundleItemType),
                    productId: '15178612048243',
                    variantId: '62111430443379',
                },
            ],
        },
        // {
        //     ...({} as BundleItemType),
        //     btn: 'Coming Soon',
        //     variantImg: 'https://websiteoss.ecoflow.com/upload/image/1758781342217/DPUX_2EB_SHP3.png',
        //     productTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery + 1 × EcoFlow Smart Home Panel 3',
        //     power: '12kWh | 12kW | 120V & 240V',
        //     desc: 'The Ultimate Whole-Home Power Command Center',
        // },
        // {
        //     ...({} as BundleItemType),
        //     btn: 'Coming Soon',
        //     productTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery + 1 × EcoFlow Smart Gateway(200A)',
        //     power: '12kWh | 12kW | 120V & 240V',
        //     desc: 'Set it and Forget it, Energy Simplified.',
        //     variantImg: 'https://websiteoss.ecoflow.com/upload/image/1758781342063/DPUX_2EB_ATS.png',
        // },
        {
            ...({} as BundleItemType),
            productId: '8006700236954',
            variantId: '44244774682778',
        },
    ],
};
